import React, { useState, useMemo } from 'react'
import { Tabs, Tab, Box } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import {
    resetSharedUids,
    setMultiMetaSharedUid,
    setObjectSharedUid,
} from '../../../../../../features/genericCommentsAndFilesSlice'
import ReceiptsCommentsAndFiles from "../TabModule/ReceiptsCommentsAndFiles";

export default function ReceiptDiscussionTabs() {
    const [value, setValue] = useState(0)
    const dispatch = useDispatch()
    const { selectedRow } = useSelector((state: any) => state.receipts)

    const receiptLabels = useMemo(() => {
        return (
            selectedRow?.map((row: any) => {
                return {
                    label: `${row?.receipt_id}`,
                    receipt_shared_uid: row?.receipt_shared_uid,
                }
            }) || []
        )
    }, [selectedRow])

    const tabConfig = useMemo(() => {
        const sharedUids = receiptLabels
            ?.map((label: any) => label?.receipt_shared_uid)
            ?.reverse()
        return [
            {
                label: 'ALL RECEIPTS',
                receipt_shared_uid: '',
                component: () => (
                    <ReceiptsCommentsAndFiles
                      type="all"
                      objectType="collection_event"
                      referenceModule="Receipts"
                      moduleType="receipts"
                      objectSharedUid={sharedUids.length ? sharedUids : []}
                      postCommentTrackID="601"
                      reactionTrackID="602"
                      uploadFileTrackID="598"
                      downloadFileTrackID="599"
                      previewFileTrackID="600"
                    />
                )
            },
            ...receiptLabels?.map(({ label, receipt_shared_uid }: any) => ({
                label,
                receipt_shared_uid,
                component: () => (
                    <ReceiptsCommentsAndFiles
                        type="single"
                        objectType="collection_event"
                        referenceModule="Receipts"
                        moduleType="receipts"
                        objectSharedUid={receipt_shared_uid}
                        postCommentTrackID="601"
                        reactionTrackID="602"
                        uploadFileTrackID="598"
                        downloadFileTrackID="599"
                        previewFileTrackID="600"
                    />
                )
            })),
        ]
    }, [receiptLabels])

    const handleChange = (_: React.SyntheticEvent, newValue: number) => {
        dispatch(resetSharedUids())
        setValue(newValue)
        const selectedTab = tabConfig[newValue]
        if (newValue === 0) {
            const sharedUids = receiptLabels
                ?.map((label: any) => label?.receipt_shared_uid)
                ?.reverse()
            dispatch(setMultiMetaSharedUid(sharedUids))
        } else {
            dispatch(setObjectSharedUid(selectedTab.receipt_shared_uid))
        }
    }

    if (!selectedRow || selectedRow?.length === 0 || tabConfig?.length === 0) {
        return (
            <Box sx={{ p: 2, textAlign: 'center' }}>
                <p>No receipts available.</p>
            </Box>
        )
    }

    const ActiveComponent = tabConfig[value]?.component
    return (
        <>
            <Box sx={{ bgcolor: '#fff' }}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    data-tracker="597"
                    aria-label="forecast modules"
                    sx={{
                        px: 2,
                        '& .MuiTabs-indicator': {
                            backgroundColor: '#7B1FA2',
                        },
                    }}
                >
                    {tabConfig?.map((tab, index) => (
                        <Tab
                            data-tracker="597"
                            key={index}
                            label={tab.label}
                            sx={{
                                fontWeight: 'bold',
                                textTransform: 'none',
                                '&.Mui-selected': {
                                    color: '#7B1FA2',
                                },
                            }}
                        />
                    ))}
                </Tabs>
            </Box>
            <Box sx={{ p: 2 }}>{ActiveComponent && <ActiveComponent />}</Box>
        </>
    )
}
